import { render, staticRenderFns } from "./PresentationsSection.vue?vue&type=template&id=5545c64a&scoped=true"
import script from "./PresentationsSection.vue?vue&type=script&lang=js"
export * from "./PresentationsSection.vue?vue&type=script&lang=js"
import style0 from "./PresentationsSection.vue?vue&type=style&index=0&id=5545c64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545c64a",
  null
  
)

export default component.exports